<div class="row">
 
  <div class="col-sm-12 col-lg-4 form-group">
    <input type="text" placeholder="Fecha de Inicio" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false }"
      [(bsValue)]="fechaInicio" [maxDate]="fechaFin" [minDate]="minFechaInicio" readonly>
  </div>
  <div class="col-sm-12 col-lg-4 form-group">
    <input type="text" placeholder="Fecha Fin" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false}"
      [(bsValue)]="fechaFin" [minDate]="fechaInicio" readonly>
  </div>


  <div class="col-12 col-sm-12 col-md-4 col-lg-3 d-flex justify-content-md-start justify-content-lg-start align-items-end">
    <button type="button" class="btn btn-outline-primary d-flex align-items-center mb-4" (click)="ObtenerMovimientos()">
      <span class="material-icons">search</span>
      Buscar
    </button>
  </div>


  <div class="col-12">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col" class="text-uppercase border-top-none text-left">Fecha</th>
            <th scope="col" class="text-uppercase border-top-none text-center">Documento</th>
            <th scope="col" class="text-uppercase border-top-none text-right">N° Cuota</th>
            <th scope="col" class="text-uppercase border-top-none text-right">Capital</th>
            <th scope="col" class="text-uppercase border-top-none text-right">Interés</th>
            <th scope="col" class="text-uppercase border-top-none text-right">Otros</th>
            <th scope="col" class="text-uppercase border-top-none text-right">Valor pagado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="movimientosLista?.length === 0">
            <td colspan="7" class="text-uppercase text-center">No hay información para mostrar</td>
          </tr>
          <tr *ngFor="let movimiento of movimientosLista">
            <td class="text-left">{{movimiento?.fecha}}</td>
            <td class="text-center">{{movimiento?.documento}}</td>
            <td class="text-right">{{movimiento?.cuota}}</td>
            <td class="text-right">{{movimiento?.capital | currency}}</td>
            <td class="text-right">{{movimiento?.interes | currency}}</td>
            <td class="text-right">{{movimiento?.otros | currency}}</td>
            <td class="text-right">{{movimiento?.total | currency}}</td>
          </tr>
        </tbody>
      </table>
  


  <div class="d-flex justify-content-between p-2">
    <ngb-pagination [collectionSize]="cantidad" [(page)]="pagina" [pageSize]="paginaTamanio" [rotate]="true"
                    [maxSize]="5" [boundaryLinks]="true" (pageChange)="ObtenerMovimientos()">
    </ngb-pagination>

    <select class="custom-select" style="width: auto" [(ngModel)]="paginaTamanio"
            (ngModelChange)="ObtenerMovimientos()">
      <option [ngValue]="3">3 movimientos por página</option>
      <option [ngValue]="5">5 movimientos por página</option>
      <option [ngValue]="10">10 movimientos por página</option>
    </select>
  </div>
</div>
</div>
</div>
